import type { PayStub } from "./types";

export const API_URL =
  process.env.REACT_APP_API_URL || "https://api.getnovala.com";

export const getToken = (): string =>
  localStorage.getItem("access_token") || localStorage.getItem("token") || "";

export const authHeaders = (): Record<string, string> => ({
  Authorization: "Bearer " + getToken(),
  "Content-Type": "application/json",
});

export const formatCurrency = (
  value: number | string | null | undefined,
  currency?: string
): string => {
  if (value === null || value === undefined) return "$0.00";
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num)) return "$0.00";
  try {
    return new Intl.NumberFormat("en-CA", {
      style: "currency",
      currency: currency || "CAD",
    }).format(num);
  } catch (e) {
    return num.toFixed(2);
  }
};

export const formatDate = (dateStr: string | null | undefined): string => {
  if (!dateStr) return "";
  try {
    return new Date(dateStr).toLocaleDateString("en-CA", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch (e) {
    return dateStr;
  }
};

export const getStubName = (stub: PayStub): string => {
  return (
    stub.employee_name ||
    stub.employee?.name ||
    [stub.employee?.first_name, stub.employee?.last_name]
      .filter(Boolean)
      .join(" ") ||
    (stub.first_name && stub.last_name
      ? stub.first_name + " " + stub.last_name
      : "") ||
    "Unnamed"
  );
};